import { SelectedTenant } from '@/config/initialState';
import { store } from '@/config/store';

/**
 * 顧客 customerId が選んだテナント切り替えだけを返す。
 * 切り替えは選んだ顧客に対してだけ有効で、車両切り替え等で別の顧客（別の所属法人）に
 * なった後は無効（null）として扱う。切り替え可否は所属法人ごとに違うため。
 * 未ログイン（顧客ID 0）どうしでは一致させない。
 */
export const selectedTenantFor = (
  customerId: number | null | undefined,
  tenant: SelectedTenant = store.state.selectedTenant,
): SelectedTenant =>
  tenant &&
  customerId != null &&
  customerId > 0 &&
  tenant.source_m_customer_id === customerId
    ? tenant
    : null;
